import type { PaginationQuery } from '../../../types/pagination';
import { appendPaginationQuery } from '../../../types/pagination';
import type { ApiClient } from '../client';
import type { Uuid } from '../types/common';
import type {
  AddInventoryStockRequest,
  CreateInventoryItemRequest,
  IssueInventoryStockRequest,
  ListInventoryItemsResponse,
  ListInventoryMovementsResponse,
  InventoryStockMovementResponse,
  ReturnInventoryStockRequest,
} from '../types/inventory';

export function bindInventory(client: ApiClient) {
  return {
    async listInventoryItems(
      params?: PaginationQuery & { category?: string; low_stock?: boolean }
    ) {
      const qs = new URLSearchParams();
      appendPaginationQuery(qs, params);
      if (params?.category?.trim()) qs.set('category', params.category.trim());
      if (params?.low_stock) qs.set('low_stock', 'true');
      const query = qs.toString();
      const path = query ? `/inventory/items?${query}` : '/inventory/items';
      return client.request<ListInventoryItemsResponse>(path);
    },

    async createInventoryItem(body: CreateInventoryItemRequest) {
      return client.request<{ item_id: Uuid }>('/inventory/items', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async addInventoryStock(body: AddInventoryStockRequest) {
      return client.request<InventoryStockMovementResponse>('/inventory/stock/add', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async issueInventoryStock(body: IssueInventoryStockRequest) {
      return client.request<InventoryStockMovementResponse>('/inventory/issue', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async returnInventoryStock(body: ReturnInventoryStockRequest) {
      return client.request<InventoryStockMovementResponse>('/inventory/return', {
        method: 'POST',
        body: JSON.stringify(body),
      });
    },

    async listInventoryMovements(params?: PaginationQuery & { item_id?: string }) {
      const qs = new URLSearchParams();
      appendPaginationQuery(qs, params);
      if (params?.item_id?.trim()) qs.set('item_id', params.item_id.trim());
      const query = qs.toString();
      const path = query ? `/inventory/movements?${query}` : '/inventory/movements';
      return client.request<ListInventoryMovementsResponse>(path);
    },
  };
}
